import { createStore, applyMiddleware, compose } from 'redux';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist6';
import storage from 'redux-persist6/lib/storage';
import { composeWithDevTools } from 'redux-devtools-extension';

import rootReducer from '../reducers';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: [
    'globalSearch',
    'userGroups',
    'recentProductSearch',
    'dismissFeatures',
    'generalManagerStores',
    'managerDateFilter',
    'emailPreferences',
    'calendarRange',
  ],
};

const createStoreWithLogging = () => applyMiddleware(createLogger());
const createStoreWithMiddleware = () => applyMiddleware(thunk);
let finalCreateStore;

if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test') {
  finalCreateStore = composeWithDevTools(createStoreWithMiddleware(), createStoreWithLogging())(createStore);
} else {
  finalCreateStore = compose(createStoreWithMiddleware())(createStore);
}

const configureStore = (initialState) => {
  const persistedReducer = persistReducer(persistConfig, rootReducer);
  const store = finalCreateStore(persistedReducer, initialState);
  const persistor = persistStore(store);
  if (module.hot) {
    module.hot.accept('../reducers', () =>
      /* eslint-disable-next-line */
      store.replaceReducer(persistReducer(persistConfig, require('../reducers').default)),
    );
  }

  return { store, persistor };
};

const initialState = {};

const { store, persistor } = configureStore(initialState);

export { store, persistor };
